import {handleActions} from 'redux-actions';
import {Map, List} from 'immutable';

import * as InstitutionActions from 'web-app/react/entities/institutions/actions';
import AreaActionTypes from 'web-app/react/entities/areas/action-types';
import RoleActionTypes from 'web-app/react/entities/roles/action-types';

import Organization from './model';
import * as Actions from './actions';

export default handleActions(
    {
        [Actions.fetch.type]: (state, {payload}) =>
            state.update(payload.organizationId, () => Organization.fetchingDummy),

        [Actions.fetchSuccess.type]: (state, {payload}) =>
            state.update(payload.organization.organizationId, () => payload.organization),

        [InstitutionActions.fetchAllSuccess.type]: (state, {payload}) => {
            if (state.has(payload.organizationId)) {
                return state.update(payload.organizationId, organization => {
                    return organization.merge({
                        institutionIds: List(payload.institutions).map(inst => inst.institutionId),
                    });
                });
            }
            return state;
        },

        [AreaActionTypes.AREA_FETCH_ALL_SUCCESS]: (state, {payload}) => {
            if (state.has(payload.organizationId)) {
                return state.update(payload.organizationId, organization => {
                    return organization.merge({
                        areaIds: List(payload.areas.toList().map(area => area.areaId)),
                    });
                });
            }
            return state;
        },

        [RoleActionTypes.FETCH_FOR_ORGANIZATION_SUCCESS]: (state, {payload}) => {
            const {organizationId, roles} = payload;
            return state.update(organizationId, organization => {
                return organization.merge({
                    roleIds: roles.map(role => role.roleId),
                });
            });
        },
    },
    Map(),
);
